import * as React from 'react';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { UIHeading2 } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { getGaLabel, getNewbuildingId } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/withApplicationContext';
import { BuilderChatButtonContainer } from '../BuilderChatButton';
import { trackShowPhone } from './tracking';
import { IBuilder } from '../../types/newbuilding/builder';

interface IContactsContainerProps {
  builder: IBuilder;
}

const CALL_BUTTON_STYLES = {
  size: 'M' as const,
  beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
};

export function ContactsContainer({ builder }: IContactsContainerProps) {
  const gaLabel = useSelector(getGaLabel);
  const newbuildingId = useSelector(getNewbuildingId);

  const hasPhone = builder.phone && builder.phone.number;
  const hasChat = builder.chat?.isEnabled && builder.realtyUserId;

  const chatContacts = React.useMemo(() => {
    return {
      builders: [builder],
      sellers: [],
    };
  }, [builder]);

  const { httpApi, logger } = useApplicationContext();

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'builderBlock';

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone({
      gaLabel,
      newbuildingId,
      isBuilder: true,
    });
  }, [gaLabel, newbuildingId]);

  if (!hasPhone && !hasChat) {
    return null;
  }

  return (
    <>
      {hasPhone && (
        <SimpleCall
          builders={[builder]}
          sellers={[]}
          onShowPhoneClick={onShowPhoneClick}
          openContactsStyles={CALL_BUTTON_STYLES}
          showPhoneStyles={CALL_BUTTON_STYLES}
          SinglePhoneComponent={({ phone }: { phone: string }) => <UIHeading2 whiteSpace="nowrap">{phone}</UIHeading2>}
          httpApi={httpApi}
          logger={logger}
          pageType={pageType}
          platformType={platformType}
          placeType={placeType}
          singlePhoneButtonText="Показать телефон"
        />
      )}
      {hasChat && <BuilderChatButtonContainer forcedContacts={chatContacts} />}
    </>
  );
}
